<div class="item-page-field">
  <!-- <ds-metadata-values [mdValues]="item?.allMetadata(fields)" [separator]="separator" [label]="label"></ds-metadata-values> -->
  <ds-metadata-values [useGcWeb]="true" [subheading]="subheading" [filterLang]="filterLang" [mdValues]="fields | metaTranslate: item" [separator]="separator" [label]="label"></ds-metadata-values>
</div>
